import getCountryISO2 from 'country-iso-3-to-2';

const IocCountries = {
  ALG: 'DZA',
  ASM: 'ASA',
  AGO: 'ANG',
  ATG: 'ANT',
  ARU: 'ABW',
  BAH: 'BHS',
  BRN: 'BHR',
  BAN: 'BGD',
  BAR: 'BRB',
  BIZ: 'BLZ',
  BER: 'BMU',
  BHU: 'BTN',
  BOT: 'BWA',
  IVB: 'VGB',
  BRU: 'BRN',
  BUL: 'BGR',
  BUR: 'BFA',
  CAM: 'KHM',
  CAY: 'CYM',
  CHA: 'TCD',
  CHI: 'CHL',
  CGO: 'COG',
  CRC: 'CRI',
  CRO: 'HRV',
  DEN: 'DNK',
  ESA: 'SLV',
  GEQ: 'GNQ',
  FIJ: 'FJI',
  GAM: 'GMB',
  GER: 'DEU',
  GRE: 'GRC',
  GRN: 'GRD',
  GUA: 'GTM',
  GUI: 'GIN',
  GBS: 'GBN',
  HAI: 'HTI',
  HON: 'HND',
  INA: 'IDN',
  IRI: 'IRN',
  KOS: 'XKX',
  KUW: 'KWT',
  LAT: 'LVA',
  LES: 'LSO',
  LBA: 'LBY',
  MAD: 'MDG',
  MAW: 'MWI',
  MAS: 'MYS',
  MTN: 'MRT',
  MRI: 'MUS',
  MON: 'MCO',
  MGL: 'MNG',
  MYA: 'MMR',
  NEP: 'NPL',
  NED: 'NLD',
  NCA: 'NIC',
  NIG: 'NER',
  NGR: 'NGA',
  OMA: 'OMN',
  PLE: 'PSE',
  PAR: 'PRY',
  PHI: 'PHL',
  POR: 'PRT',
  PUR: 'PRI',
  SKN: 'KNA',
  VIN: 'VCT',
  SAM: 'WSM',
  KSA: 'SAU',
  SEY: 'SYC',
  SLO: 'SVN',
  SOL: 'SLB',
  RSA: 'ZAF',
  SRI: 'LKA',
  SUD: 'SDN',
  SUI: 'CHE',
  TPE: 'TWN',
  TAN: 'TZA',
  TOG: 'TGO',
  TGA: 'TON',
  UAE: 'ARE',
  ISV: 'VIR',
  URU: 'URY',
  VAN: 'VUT',
  VIE: 'VNM',
  ZAM: 'ZMB',
  ZIM: 'ZWE'
};

const CountryFlag = (country, ioc = true) => {
  if (!country) return undefined;
  let flagname = country.toUpperCase();

  if (ioc && flagname.length === 3) {
    if (IocCountries[country.toUpperCase()]) {
      flagname = IocCountries[country.toUpperCase()];
    }
  }

  if (!flagname || flagname.length === 3) {
    flagname = getCountryISO2(flagname ? flagname.toUpperCase() : country.toUpperCase());
  }

  if (flagname) {
    return `https://resources.redbull.com/icons/flags/v2/${flagname.toUpperCase()}.png`;
  }

  return undefined;
};

export { CountryFlag };
